/** Blocks (a thread's result, an insight, a page, a measure page) and the thread they are shown in. */
export const appBlocksEn = {
  blocks: {
    chart: {
      now: "Now",
      before: "Before",
      against: "Against the period before",
      name: "Name",
      value: "Value",
      share: "Share",
      weekdays: "Mon,Tue,Wed,Thu,Fri,Sat,Sun",
      dropped: "dropped off",
      preliminary: "Not final yet",
      preliminaryNote: "The shaded part is too recent to be final. It may still change.",
      from: "from {{count}}",
      fromWhat: "from {{count}} {{what}}",
    },
    number: {
      change: "{{change}} against before",
      changeDay: "{{change}} against the day before",
      day: "{{day}}",
      finalDay: "{{day}}, the latest final day",
      normal: "Normally between {{low}} and {{high}}",
      forming: "Adea is still learning what is normal here",
    },
    table: {
      truncated: "Showing {{shown}} of {{total}} rows",
      more: "{{count}} more",
    },
    code: {
      source: "In the code:",
      replay: "Play it again",
      flow: "How it works",
      tree: "How it works, part by part",
      expand: "Show the parts under it",
      collapse: "Hide the parts under it",
    },
    graph: {
      label: "How they connect",
      one_to_many: "one to many",
      many_to_one: "many to one",
      one_to_one: "one to one",
      many_to_many: "many to many",
      flow: "feeds",
    },
    timeline: {
      label: "What happened",
      by: "by {{actor}}",
    },
    callout: {
      fact: "Worth knowing",
      warning: "Watch out",
      good: "Good news",
    },
    analysis: {
      method: "How it was worked out",
      caveats: "Keep in mind",
      cohort: {
        corner: "Started",
        size: "People",
        all: "All",
        measure: "still there",
        tip: "{{share}} {{measure}} · {{kept}} of {{size}}",
        quarter: "Q{{q}} {{year}}",
        week: "Week of {{date}}",
        since: {
          hour: "Hours since",
          day: "Days since",
          week: "Weeks since",
          month: "Months since",
          quarter: "Quarters since",
          year: "Years since",
        },
        at: {
          hour: "hour {{n}}",
          day: "day {{n}}",
          week: "week {{n}}",
          month: "month {{n}}",
          quarter: "quarter {{n}}",
          year: "year {{n}}",
        },
      },
      forecast: {
        actual: "Actual",
        ahead: "Forecast",
        range: "Where it will most likely land",
      },
      test: {
        veryLikely: "Very likely a real difference",
        likely: "Likely a real difference",
        maybe: "Could be chance",
        unclear: "No clear difference",
        difference: "Difference",
        points: "{{n}} points",
        more: "{{share}} more",
        less: "{{share}} less",
        range: "The real difference is most likely between {{low}} and {{high}} ({{level}} confidence).",
        n: "of {{n}}",
      },
      spread: {
        median: "Median",
        mean: "Average",
        middle: "Middle 80%",
        count: "Values",
      },
    },
  },
  thread: {
    you: "You",
    adea: "Adea",
    thinking: "Thinking…",
    rail: "What Adea looked at",
    steps_one: "Looked at {{count}} thing",
    steps_other: "Looked at {{count}} things",
    showSteps: "Show what Adea looked at",
    hideSteps: "Hide",
    step: {
      schema: "Looking through the tables",
      table: "Reading the {{name}} table",
      query: "Writing a query",
      adjust: "Adjusting the query",
      record: "Finding {{name}}",
      codeSearch: "Searching the code for {{name}}",
      code: "Reading {{name}}",
      history: "Reading the code's history",
      python: "Working it out",
      understanding: "Reading what Adea knows about {{name}}",
      recipe: "Running {{name}}",
      spawn: "Looking at several things at once",
      ask: "Asking you",
      other: "Working",
    },
    failedStep: "Didn't work: {{reason}}",
    asks: "Adea asks",
    asked: "You answered: {{answer}}",
    failed: "Adea couldn't finish this answer.",
    retry: "Try again",
    stopped: "Stopped before it was done.",
    followUp: "Ask a follow-up",
    send: "Send",
    stop: "Stop",
    attach: "Add a picture",
    removeAttachment: "Remove picture",
    picture: "A picture you added",
    keep: "Keep this",
    askAbout: "Ask about this",
    source: "Source",
    sources: "What this rests on",
    explore: "Explore",
  },
};
